import i18n from '@/i18n';

const tc = (key) => i18n.t(key, { ns: 'common' });

const getRoleLabels = () => ({
  superadmin: tc('roles.superadmin'),
  admin: tc('roles.admin'),
  teacher: tc('roles.teacher'),
  student: tc('roles.student'),
  corporation: tc('roles.corporation'),
});

export const ADMIN_ROLE_SLUGS = [
  'superadmin',
  'admin'
];

const capitalizeWord = (word) => {
  if (!word) return '';
  return word.charAt(0).toUpperCase() + word.slice(1);
};

export const formatRoleLabel = (roleName) => {
  if (!roleName) return tc('roles.na');
  const labels = getRoleLabels();
  if (labels[roleName]) return labels[roleName];
  return roleName
    .split('_')
    .map(capitalizeWord)
    .join(' ');
};

export const getRoleInvitePermission = (roleName) => `hr.invitations.invite.${roleName}`;
